import type React from 'react';
import { Typography, Stack, Box } from '@mui/material';

import type { TestProps } from '../../models';
import { fCurrency } from '../../utils/formatNumber';

interface TestsProps {
	tests: TestProps[];
}

/*
 Selected tests total summary
*/
export const TestSelectionSummary = ({ tests }: TestsProps) => {
	return (
		<>
			{tests.map((test) => {
				const unitPrice = test.discountedPrice ?? test.price;

				return (
					<Stack key={test.id} direction="row" justifyContent="space-between" alignItems="flex-start">
						<Box>
							<Typography variant="body1">
								{test.quantity} <strong>×</strong> {test.name}
							</Typography>
						</Box>
						<Box sx={{ textAlign: 'right' }}>
							<Typography variant="body1" sx={{ fontWeight: 'fontWeightBold', color: 'text.primary' }}>
								{fCurrency(unitPrice * (test.quantity || 1))}
							</Typography>
							<Typography variant="body2">{fCurrency(unitPrice)} ea</Typography>
						</Box>
					</Stack>
				);
			})}
		</>
	);
};
